import * as colors from "@mui/material/colors";

function getThemePalette(defaultTheme) {
	const mui_colors = [
		"red",
		"pink",
		"purple",
		"deepPurple",
		"indigo",
		"blue",
		"lightBlue",
		"cyan",
		"teal",
		"green",
		"lightGreen",
		"lime",
		"yellow",
		"amber",
		"orange",
		"deepOrange",
		"brown",
		"grey",
		"blueGrey",
	];

	const darkColor = {
		lighter: colors.grey["700"],
		light: colors.grey["800"],
		main: colors.grey["900"],
		dark: colors.grey["900"],
		darker: colors.grey["900"],
		contrastText: defaultTheme.palette.getContrastText(colors.grey["900"]),
	};
	const footerColor = { ...darkColor };
	const lightColor = {
		lighter: "#fff",
		light: colors.grey["100"],
		main: colors.grey["100"],
		dark: colors.grey["200"],
		darker: colors.grey["200"],
		contrastText: defaultTheme.palette.getContrastText(colors.grey["100"]),
	};
	const greyColor = {
		lighter: colors.grey["400"],
		light: colors.grey["500"],
		main: colors.grey["600"],
		dark: colors.grey["700"],
		darker: colors.grey["800"],
		contrastText: lightColor.light,
	};
	const linksColor = {
		lighter: colors.blue["400"],
		light: colors.blue["500"],
		main: colors.blue["600"],
		dark: colors.blue["700"],
		darker: colors.blue["800"],
		contrastText: defaultTheme.palette.getContrastText(colors.blue["600"]),
	};

	const palette = {
		...defaultTheme.palette,
		primary: { ...darkColor },
		secondary: { ...greyColor },
		link: { ...linksColor },
		appBar: {
			private: {
				...lightColor,
				contrastText: defaultTheme.palette.getContrastText(lightColor.main),
			},
			public: {
				...darkColor,
				contrastText: defaultTheme.palette.getContrastText(darkColor.main),
			},
		},
		titleBar: {
			private: {
				...lightColor,
			},
			public: {
				...greyColor,
			},
		},
		body: {
			lighter: "#ffffff",
			light: colors.grey["50"],
			main: colors.grey["100"],
			dark: colors.grey["200"],
			darker: colors.grey["300"],
			contrastText: defaultTheme.palette.getContrastText(colors.grey["100"]),
		},
		footer: footerColor,
		link: {
			...defaultTheme.palette.primary,
			contrastText: defaultTheme.palette.getContrastText(
				defaultTheme.palette.primary.main
			),
		},
		dark: darkColor,
		light: lightColor,
		info: {
			lighter: colors.blue["400"],
			light: colors.blue["500"],
			main: colors.blue["600"],
			dark: colors.blue["700"],
			darker: colors.blue["800"],
			contrastText: defaultTheme.palette.getContrastText(colors.blue["500"]),
		},
	};
	mui_colors.forEach((color) => {
		const colorObj = colors[color];
		palette[color] = {
			lighter: colorObj["100"],
			light: colorObj["200"],
			main: colorObj["300"],
			dark: colorObj["400"],
			darker: colorObj["500"],
			contrastText: defaultTheme.palette.getContrastText(colorObj["300"]),
		};
	});

	return palette;
}

export default getThemePalette;
